export default "__VITE_ASSET__1f4e35e9__"